import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M2.27083 17.5C2.11806 17.5 1.97917 17.4618 1.85417 17.3854C1.72917 17.309 1.63195 17.2083 '
  + '1.5625 17.0833C1.49306 16.9583 1.45486 16.8229 1.44792 16.6771C1.44097 16.5312 1.47917 '
  + '16.3889 1.5625 16.25L9.27083 2.91667C9.35417 2.77778 9.46181 2.67361 9.59375 2.60417C9.7257 '
  + '2.53472 9.86111 2.5 10 2.5C10.1389 2.5 10.2743 2.53472 10.4063 2.60417C10.5382 2.67361 '
  + '10.6458 2.77778 10.7292 2.91667L18.4375 16.25C18.5208 16.3889 18.559 16.5312 18.5521 '
  + '16.6771C18.5451 16.8229 18.5069 16.9583 18.4375 17.0833C18.3681 17.2083 18.2708 17.309 '
  + '18.1458 17.3854C18.0208 17.4618 17.8819 17.5 17.7292 17.5H2.27083ZM3.70833 '
  + '15.8333H16.2917L10 5L3.70833 15.8333ZM10 15C10.2361 15 10.434 14.9201 10.5938 '
  + '14.7604C10.7535 14.6007 10.8333 14.4028 10.8333 14.1667C10.8333 13.9306 10.7535 13.7326 '
  + '10.5938 13.5729C10.434 13.4132 10.2361 13.3333 10 13.3333C9.76389 13.3333 9.56597 13.4132 '
  + '9.40625 13.5729C9.24653 13.7326 9.16667 13.9306 9.16667 14.1667C9.16667 14.4028 9.24653 '
  + '14.6007 9.40625 14.7604C9.56597 14.9201 9.76389 15 10 15ZM10 12.5C10.2361 12.5 10.434 '
  + '12.4201 10.5938 12.2604C10.7535 12.1007 10.8333 11.9028 10.8333 11.6667V9.16667C10.8333 '
  + '8.93056 10.7535 8.73264 10.5938 8.57292C10.434 8.41319 10.2361 8.33333 10 8.33333C9.76389 '
  + '8.33333 9.56597 8.41319 9.40625 8.57292C9.24653 8.73264 9.16667 8.93056 9.16667 '
  + '9.16667V11.6667C9.16667 11.9028 9.24653 12.1007 9.40625 12.2604C9.56597 12.4201 9.76389 12.5 '
  + '10 12.5Z'

const WarningIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH} fill="currentColor" />
  </svg>
)

WarningIcon.propTypes = {
  className: PropTypes.string
}

WarningIcon.defaultProps = {
  className: 'tw:h-6 tw:w-6'
}

export default WarningIcon
